import ErrorMessage from "../Simple/ErrorMessage";

export default function ApiError({ error }) {
    if (!error) return null;
    
    if (error.response && error.response.data) {
        if ((error.response.status === 400 || error.status === 400) && error.response.data.errors && !error.response.data.errors.request) {
            const validationErrors = error.response.data.errors;
            const keys = Object.keys(validationErrors);
    
            return (
                <ErrorMessage errors={keys.map(k => validationErrors[k])} />
            );
        }
    
        if ((error.response.status === 422 || error.status === 422) && error.response.data.errors) {
            const errors = error.response.data.errors;
            return (
                <ErrorMessage errors={errors} />
            );
        }

        if ((error.response.status === 404 || error.status === 404) && error.response.data.message) {
            return (<ErrorMessage errors={[
                error.response.data.message
            ]} />);
        }
    } else if (error.errors) {
        return <ErrorMessage errors={error.errors} />;
    } else if (error.message) {
        return (<ErrorMessage errors={[
            error.message
        ]} />);
    }    

    return (<ErrorMessage errors={["Failed to submit"]} />);
}